import { render, staticRenderFns } from "./work-item-child-list.component.vue?vue&type=template&id=defefc48&scoped=true&"
import script from "./work-item-child-list.component.vue?vue&type=script&lang=ts&"
export * from "./work-item-child-list.component.vue?vue&type=script&lang=ts&"
import style0 from "./work-item-child-list.component.vue?vue&type=style&index=0&id=defefc48&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defefc48",
  null
  
)

export default component.exports